export default function BubblePopIcon() {
  const b = (x: number, y: number, c: string, d: string, r = 7) => (
    <g key={`${x}-${y}`}>
      <circle cx={x} cy={y} r={r} fill={c} stroke={d} strokeWidth="1.5" />
      <ellipse cx={x - r * 0.38} cy={y - r * 0.4} rx={r * 0.28} ry={r * 0.16} fill="#fff" opacity="0.75" transform={`rotate(-40 ${x - r * 0.38} ${y - r * 0.4})`} />
    </g>
  );
  return (
    <svg viewBox="0 0 64 64" aria-hidden="true">
      <rect x="2" y="2" width="60" height="60" rx="10" fill="#1d3a8a" />
      <rect x="2" y="2" width="60" height="6" rx="3" fill="#6a3ad0" />
      {b(11, 15, '#ff4d6d', '#a3102f')}
      {b(25, 15, '#ff4d6d', '#a3102f')}
      {b(39, 15, '#3ddc84', '#11793e')}
      {b(53, 15, '#3aa0ff', '#0d4f99')}
      {b(18, 27, '#ffe14d', '#a88a00')}
      {b(32, 27, '#3ddc84', '#11793e')}
      {b(46, 27, '#3aa0ff', '#0d4f99')}
      <path d="M32 52 L40 38" stroke="#fff" strokeWidth="2" strokeDasharray="2 3" strokeLinecap="round" />
      <circle cx="32" cy="55" r="10" fill="#3156a8" stroke="#74b6ff" strokeWidth="2" />
      {b(32, 55, '#b45cff', '#5f1a9e', 6.5)}
    </svg>
  );
}
